<template>
  <div class="member-project ">
    <header-back
      title="星轨询盘"
      @back="resetHandler"
    />
    <div class="member-project-box">
      <i class="empty-pic" />
      <p>
        会员管理项目暂未提供移动版本
        请前往电脑端使用
      </p>
      <router-link :to="{name: 'OrgIndex', query: { page: 2}}">知道了</router-link>
    </div>
  </div>
</template>

<script>
import HeaderBack from '@/components/mobile/HeaderBack'
export default {
  components: {
    HeaderBack
  },
  data () {
    return {
    }
  },
  computed: {
  },
  async mounted () {
  },
  methods: {
    resetHandler () {
      this.$router.push({
        name: 'OrgIndex',
        query: {
          page: 2
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.member-project {
  background: #fff;
  height: 100%;
}
.member-project-box {
   margin: 60px auto;
   text-align: center;
   width: 246px;
  .empty-pic {
    width: 160px;
    height: 160px;
    display: block;
    margin: 0 auto 30px;
    background: url('../../assets/images/memberpro.jpg') no-repeat 0 0;
    background-size:160px 160px; ;
  }
  p{
    line-height: 24px;
    color: #808080;
    padding-bottom: 16px;

  }
}
</style>
